export const MANUFACTURERS = '/manufacturers'
